var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 44,
    d: "M465 127 241 384l-92-92m-9 93-93-93m316-165L236 273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAll);
export default __webpack_public_path__ + "static/media/CheckAll.1caacbc2d031573547ffe716b62e3760.svg";
export { ForwardRef as ReactComponent };